import {getProperties} from '@telstra-connect/legislations/properties'

const servicePerformanceFeatureFlags = {
  application: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  incidentsServicesEnabled: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  servicesDetailsIncidents: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  raiseIncidentButton: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  incidentPriorityNumber: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  servicesTabRedAvailability: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  mnpFaqLink: {
    Production: getProperties.MNPFAQUrl,
    PreProduction: getProperties.MNPFAQUrl,
    UAT: getProperties.MNPFAQUrl,
    SVT: getProperties.MNPFAQUrl,
    QA: getProperties.MNPFAQUrl,
    Mock: getProperties.MNPFAQUrl,
    Development: getProperties.MNPFAQUrl,
    Local: getProperties.MNPFAQUrl,
  },
  serviceDetailsPM: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  contactNumber: {
    Production: getProperties.contactNumber,
    PreProduction: getProperties.contactNumber,
    UAT: getProperties.contactNumber,
    SVT: getProperties.contactNumber,
    QA: getProperties.contactNumber,
    Mock: getProperties.contactNumber,
    Development: getProperties.contactNumber,
    Local: getProperties.contactNumber,
  },
  email: {
    Production: getProperties.email,
    PreProduction: getProperties.email,
    UAT: getProperties.email,
    SVT: getProperties.email,
    QA: getProperties.email,
    Mock: getProperties.email,
    Development: getProperties.email,
    Local: getProperties.email,
  },
  plannedMaintenanceFlag: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  pmBanner: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  hideExport: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  showSDWANExport: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  mapBoundingBox: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: false,
  },
  serviceDetailsTab: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: false,
  },
  dataQualityBanner: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  timeRangeShow24HoursDefault: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  applicationInternational: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  merakiClickable: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  billingNumberInServiceWithDataList: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  addNoHealthDataServiceDetailPage: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  veloCloudClickable: {
    Production: true,
    PreProduction: true,
    UAT: true,
    SVT: true,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  pmBannerLink: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: true,
    Mock: true,
    Development: true,
    Local: true,
  },
  checkSDWanNoAccess: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: false,
  },
  enableSDWANViptelaSSO: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: false,
  },
  addPriorityFlagToServices: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: false,
  },
  passServiceIdInsteadOfConnectionId: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: false,
  },
  enableLandingPageReDesign: {
    Production: false,
    PreProduction: false,
    UAT: false,
    SVT: false,
    QA: false,
    Mock: false,
    Development: false,
    Local: true,
  },
	SCMT11562GoogleMap: {
		Production: {bvtEnabledFeature: false, flagState: false},
    PreProduction: {bvtEnabledFeature: false, flagState: false},
    UAT: {bvtEnabledFeature: false, flagState: false},
    SVT: {bvtEnabledFeature: false, flagState: false},
    QA: {bvtEnabledFeature: true, flagState: true},
    Mock: {bvtEnabledFeature: true, flagState: true},
    Development: {bvtEnabledFeature: true, flagState: true},
    Local: {bvtEnabledFeature: true, flagState: true}
	}
}

export default servicePerformanceFeatureFlags
